const testName = (fullname) => {
  const errorMessages = {
    messages: [
      {text: 'Nome inválido.', type: 'message-error-icon'},
      {text: 'Por favor, digite seu nome e sobrenome.'}
    ]
  };

  const re = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/;
  if (!re.test(fullname)) throw errorMessages;
};

const nameCapitalize = (fullname) => {
  return fullname.map((name) => {
    name = name.toLowerCase();
    return name.charAt(0).toUpperCase() + name.slice(1);
  });
};

const nameFormat = (fullname) => {
  const errorMessages = {
    messages: [
      {text: 'Nome inválido.', type: 'message-error-icon'},
      {text: 'Por favor, digite seu nome e sobrenome.'}
    ]
  };

  fullname = fullname.trim();
  fullname = fullname.split(' ');
  fullname = fullname.filter((item) => item !== '');
  if (fullname.length < 2) throw errorMessages;
  fullname = nameCapitalize(fullname);
  fullname = fullname.toString();
  fullname = fullname.replace(/,/gi, ' ');
  return fullname;
};

export const nameValidator = (fullname) => {
  try {
    testName(fullname);
    fullname = nameFormat(fullname);
    return {status: true, fullname: fullname};
  } catch (error) {
    return {status: false, fullname: '', error};
  }
};
